import styled from "styled-components";
import { Link } from "react-router-dom";

export const NavStatusIndicator = styled.div`
  width: 5px;
  background-color: rgb(52, 58, 64);
  background-color: ${(props) =>
    props.isActive ? "#F96302" : "var(--backgroundPrimary)"};
`;

export const NavItemContainer = styled.div`
  height: 5%;
  display: flex;
  font-size: 0.9rem;
  cursor: pointer;
  background-color: rgb(52, 58, 64);
  background-color: ${(props) =>
    props.isActive ? "#000" : "var(--backgroundPrimary)"};
  @media (max-width: 768px) {
    height: 8%;
    font-size: 1rem;
  }
`;

export const NavIcon = styled.div`
  width: 3rem;
  display: flex;
  flex: 0 0 15%;
  justify-content: center;
`;

export const NavLabel = styled.div`
  width: 75%;
  align-self: center;
  line-height: 1.1rem;
`;

export const RouteLink = styled(Link)`
  text-decoration: none;
  color: #fff;
`;
